export default {
  state: {
    channels: {
      Direct: {
        color: '#FDB900',
        active: false,
      },
      Email: {
        color: '#C76BFF',
        active: false,
      },
      Display: {
        color: '#FFDD2D',
        active: false,
      },
      Social: {
        color: '#329aca',
        active: false,
      },
      Referral: {
        color: '#0099FF',
        active: false,
      },
      'Paid Search': {
        color: '#FE2B5C',
        active: false,
      },
      '(Other)': {
        color: '#FFFFFF',
        active: false,
      },
      'Organic Search': {
        color: '#3CBF73',
        active: false,
      },
    },
  },
  mutations: {
    SET_CHANNEL(state, { channel, value }) {
      state.channels[channel].active = value
    },
  },
  actions: {
    toggleChannel({ commit }, { title, active }) {
      commit('SET_CHANNEL', { channel: title, value: !active })
    },
  },
  getters: {
    allChannel(state) {
      return {
        title: 'All',
        color: '#f49329',
        active: state.labels.Sessions.active,
      }
    },
    channels(state, getters, rootState) {
      return rootState.budget.rtb.stats.channels.map((item) => ({
        ...item,
        ...state.channels[item.title],
      }))
    },
  },
}
